/**
 * Domain Mock Store
 * 도메인 계층 구조 목업 데이터를 제공합니다.
 */
import type { DomainHierarchyResponse } from '@/entities/domain/domain';
import type { DomainItem, SubDomainSearchResponse } from '@/entities/domain/domain/types';
import type { TeamOwner, UserOwner } from '@/entities/owner/domain/types';

import type { DomainUser } from '@/features/domain/api';

export const getDomainHierarchyMockData = (): DomainHierarchyResponse => {
  return {
    data: [
      {
        id: 'd665af17-bf56-4ef3-85d8-ea4100296c70',
        name: 'Manufacturing',
        displayName: '제조',
        description: '<p>제조 현장의 생산 공정 및 설비 운영 데이터를 통합 관리하는 도메인입니다.</p>',
        fullyQualifiedName: 'Manufacturing',
        children: [
          {
            id: '13374dd4-5f8b-455b-96a0-6443dccc4a68',
            name: 'Site_A',
            displayName: 'A 공장',
            description: '<p>A 공장의 제조 공정 데이터</p>',
            fullyQualifiedName: 'Manufacturing.Site_A',
            children: [
              {
                id: '77eec04d-98eb-429c-8c40-d14278c6eec8',
                name: 'CNC_Cell',
                displayName: 'CNC Cell',
                description: '<p>A 공장의 CNC 가공 셀</p>',
                fullyQualifiedName: 'Manufacturing.Site_A.CNC_Cell',
                children: [
                  {
                    id: 'c32d32c4-c01c-415d-8c56-547dd25f9652',
                    name: 'Turning',
                    displayName: '터닝 공정',
                    description: '<p>CNC Cell의 터닝 가공 공정</p>',
                    fullyQualifiedName: 'Manufacturing.Site_A.CNC_Cell.Turning',
                    children: [],
                    domainType: 'Consumer-aligned',
                    style: {},
                    version: 0.2,
                    updatedAt: 1767337947698,
                    updatedBy: 'admin',
                    parent: {
                      id: '77eec04d-98eb-429c-8c40-d14278c6eec8',
                      type: 'domain',
                      name: 'CNC_Cell',
                      fullyQualifiedName: 'Manufacturing.Site_A.CNC_Cell',
                      description: '<p>A 공장의 CNC 가공 셀</p>',
                      displayName: 'CNC Cell',
                    },
                  },
                ],
                domainType: 'Source-aligned',
                style: {},
                version: 0.1,
                updatedAt: 1765436215094,
                updatedBy: 'admin',
                parent: {
                  id: '13374dd4-5f8b-455b-96a0-6443dccc4a68',
                  type: 'domain',
                  name: 'Site_A',
                  fullyQualifiedName: 'Manufacturing.Site_A',
                  description: '<p>A 공장의 제조 공정 데이터</p>',
                  displayName: 'A 공장',
                },
              },
            ],
            domainType: 'Source-aligned',
            style: {},
            version: 0.2,
            updatedAt: 1765436112465,
            updatedBy: 'admin',
            parent: {
              id: 'd665af17-bf56-4ef3-85d8-ea4100296c70',
              type: 'domain',
              name: 'Manufacturing',
              fullyQualifiedName: 'Manufacturing',
              description: '<p>제조 현장의 생산 공정 및 설비 운영 데이터를 통합 관리하는 도메인입니다.</p>',
              displayName: '제조',
            },
          },
          {
            id: '5622f9a6-723f-43e7-a7f7-cabfb5c21995',
            name: 'Site_B',
            displayName: 'B 공장',
            description: '<p>B 공장의 제조 공정 데이터</p>',
            fullyQualifiedName: 'Manufacturing.Site_B',
            children: [
              {
                id: 'd510bfa1-5ad5-47ac-9960-9b33e733bef5',
                name: 'MCT_Cell',
                displayName: 'MCT Cell',
                description: '<p>B 공장의 MCT 가공 셀</p>',
                fullyQualifiedName: 'Manufacturing.Site_B.MCT_Cell',
                children: [
                  {
                    id: '1251bff6-dfd1-4d5c-9844-691a33f15b5a',
                    name: 'Milling',
                    displayName: '밀링 공정',
                    description: '<p>MCT Cell의 밀링 가공 공정</p>',
                    fullyQualifiedName: 'Manufacturing.Site_B.MCT_Cell.Milling',
                    children: [],
                    domainType: 'Source-aligned',
                    style: {},
                    version: 0.1,
                    updatedAt: 1765432598761,
                    updatedBy: 'admin',
                    parent: {
                      id: 'd510bfa1-5ad5-47ac-9960-9b33e733bef5',
                      type: 'domain',
                      name: 'MCT_Cell',
                      fullyQualifiedName: 'Manufacturing.Site_B.MCT_Cell',
                      description: '<p>B 공장의 MCT 가공 셀</p>',
                      displayName: 'MCT Cell',
                    },
                  },
                ],
                domainType: 'Source-aligned',
                style: {},
                version: 0.1,
                updatedAt: 1765432210158,
                updatedBy: 'admin',
                parent: {
                  id: '5622f9a6-723f-43e7-a7f7-cabfb5c21995',
                  type: 'domain',
                  name: 'Site_B',
                  fullyQualifiedName: 'Manufacturing.Site_B',
                  description: '<p>B 공장의 제조 공정 데이터</p>',
                  displayName: 'B 공장',
                },
              },
            ],
            domainType: 'Source-aligned',
            style: {},
            version: 0.2,
            updatedAt: 1765432113789,
            updatedBy: 'admin',
            parent: {
              id: 'd665af17-bf56-4ef3-85d8-ea4100296c70',
              type: 'domain',
              name: 'Manufacturing',
              fullyQualifiedName: 'Manufacturing',
              description: '<p>제조 현장의 생산 공정 및 설비 운영 데이터를 통합 관리하는 도메인입니다.</p>',
              displayName: '제조',
            },
          },
        ],
        domainType: 'Consumer-aligned',
        style: {},
        version: 0.7,
        updatedAt: 1769158862877,
        updatedBy: 'admin',
      },
      {
        id: 'ba5b2571-b2f6-48da-a22f-c0898ac0c8c1',
        name: 'Quality',
        displayName: '품질',
        description: '<p>제조 품질 관리 및 검사 데이터를 통합 관리하는 도메인입니다.</p>',
        fullyQualifiedName: 'Quality',
        children: [
          {
            id: '85048805-adc4-4293-9d9a-5cb1b265cf40',
            name: 'Inspection',
            displayName: '검사',
            description: '<p>생산 라인에서 수행되는 정규 검사 데이터를 다루는 도메인</p>',
            fullyQualifiedName: 'Quality.Inspection',
            children: [
              {
                id: '743ccea1-10e4-44a2-b9ba-5deda23f4108',
                name: 'Dimensional',
                displayName: '치수 검사',
                description: '<p>3차원 측정기 등에서 수집된 치수 검사 데이터를 관리하는 도메인</p>',
                fullyQualifiedName: 'Quality.Inspection.Dimensional',
                children: [],
                domainType: 'Source-aligned',
                style: {},
                version: 0.1,
                updatedAt: 1764208587966,
                updatedBy: 'admin',
                parent: {
                  id: '85048805-adc4-4293-9d9a-5cb1b265cf40',
                  type: 'domain',
                  name: 'Inspection',
                  fullyQualifiedName: 'Quality.Inspection',
                  description: '<p>생산 라인에서 수행되는 정규 검사 데이터를 다루는 도메인</p>',
                  displayName: '검사',
                },
              },
              {
                id: 'd6c0419f-fc91-4956-a1b8-68e6f210115a',
                name: 'Visual',
                displayName: '외관 검사',
                description: '<p>스크래치, 찍힘 등 외관 불량 검사 데이터를 다루는 도메인</p>',
                fullyQualifiedName: 'Quality.Inspection.Visual',
                children: [],
                domainType: 'Source-aligned',
                style: {},
                version: 0.1,
                updatedAt: 1764208620802,
                updatedBy: 'admin',
                parent: {
                  id: '85048805-adc4-4293-9d9a-5cb1b265cf40',
                  type: 'domain',
                  name: 'Inspection',
                  fullyQualifiedName: 'Quality.Inspection',
                  description: '<p>생산 라인에서 수행되는 정규 검사 데이터를 다루는 도메인</p>',
                  displayName: '검사',
                },
              },
            ],
            domainType: 'Source-aligned',
            style: {},
            version: 0.2,
            updatedAt: 1764208471116,
            updatedBy: 'admin',
            parent: {
              id: 'ba5b2571-b2f6-48da-a22f-c0898ac0c8c1',
              type: 'domain',
              name: 'Quality',
              fullyQualifiedName: 'Quality',
              description: '<p>제조 품질 관리 및 검사 데이터를 통합 관리하는 도메인입니다.</p>',
              displayName: '품질',
            },
          },
          {
            id: '63b02c08-b57c-4fab-8645-591dfa03de0c',
            name: 'Defect_Analysis',
            displayName: '불량 분석',
            description: '<p>검사 결과, 불량 코드, 불량률 및 원인 분석 데이터를 관리하는 도메인</p>',
            fullyQualifiedName: 'Quality.Defect_Analysis',
            children: [],
            domainType: 'Source-aligned',
            style: {},
            version: 0.2,
            updatedAt: 1763086102763,
            updatedBy: 'admin',
            parent: {
              id: 'ba5b2571-b2f6-48da-a22f-c0898ac0c8c1',
              type: 'domain',
              name: 'Quality',
              fullyQualifiedName: 'Quality',
              description: '<p>제조 품질 관리 및 검사 데이터를 통합 관리하는 도메인입니다.</p>',
              displayName: '품질',
            },
          },
          {
            id: 'dadaca9a-5784-421a-9814-67c5ad2dd4cc',
            name: 'Testing',
            displayName: '시험',
            description: '<p>제품 시험 및 검증 데이터를 관리하는 도메인</p>',
            fullyQualifiedName: 'Quality.Testing',
            children: [
              {
                id: '59d47ee9-1c87-4f68-a31c-b18c99850e93',
                name: 'Durability',
                displayName: '내구 시험',
                description: '<p>반복 하중, 장시간 운전 등 내구 시험 데이터를 다루는 도메인</p>',
                fullyQualifiedName: 'Quality.Testing.Durability',
                children: [],
                domainType: 'Source-aligned',
                style: {},
                version: 0.2,
                updatedAt: 1772526995115,
                updatedBy: 'admin',
                parent: {
                  id: 'dadaca9a-5784-421a-9814-67c5ad2dd4cc',
                  type: 'domain',
                  name: 'Testing',
                  fullyQualifiedName: 'Quality.Testing',
                  description: '<p>제품 시험 및 검증 데이터를 관리하는 도메인</p>',
                  displayName: '시험',
                },
              },
              {
                id: 'a20e23d2-924f-4d9c-84dc-1045a603b2bf',
                name: 'Environmental',
                displayName: '환경 시험',
                description: '<p>고온·저온·습도 등 환경 시험 데이터를 관리하는 도메인</p>',
                fullyQualifiedName: 'Quality.Testing.Environmental',
                children: [],
                domainType: 'Source-aligned',
                style: {},
                version: 0.1,
                updatedAt: 1764208761318,
                updatedBy: 'admin',
                parent: {
                  id: 'dadaca9a-5784-421a-9814-67c5ad2dd4cc',
                  type: 'domain',
                  name: 'Testing',
                  fullyQualifiedName: 'Quality.Testing',
                  description: '<p>제품 시험 및 검증 데이터를 관리하는 도메인</p>',
                  displayName: '시험',
                },
              },
              {
                id: '3e93335b-3b04-4238-a24d-ffece1cec098',
                name: 'Functional',
                displayName: '기능 시험',
                description: '<p>브레이크, 조향 등 기능 시험 벤치 데이터를 관리하는 도메인</p>',
                fullyQualifiedName: 'Quality.Testing.Functional',
                children: [],
                domainType: 'Source-aligned',
                style: {},
                version: 0.1,
                updatedAt: 1764208679118,
                updatedBy: 'admin',
                parent: {
                  id: 'dadaca9a-5784-421a-9814-67c5ad2dd4cc',
                  type: 'domain',
                  name: 'Testing',
                  fullyQualifiedName: 'Quality.Testing',
                  description: '<p>제품 시험 및 검증 데이터를 관리하는 도메인</p>',
                  displayName: '시험',
                },
              },
            ],
            domainType: 'Consumer-aligned',
            style: {},
            version: 0.2,
            updatedAt: 1769589086211,
            updatedBy: 'admin',
            parent: {
              id: 'ba5b2571-b2f6-48da-a22f-c0898ac0c8c1',
              type: 'domain',
              name: 'Quality',
              fullyQualifiedName: 'Quality',
              description: '<p>제조 품질 관리 및 검사 데이터를 통합 관리하는 도메인입니다.</p>',
              displayName: '품질',
            },
          },
        ],
        domainType: 'Aggregate',
        style: {},
        version: 0.5,
        updatedAt: 1769597514838,
        updatedBy: 'admin',
      },
      {
        id: 'e7a1f2d3-c4b5-4678-9abc-def012340001',
        name: 'LGES',
        displayName: 'LGES',
        description:
          '<p>LG에너지솔루션(LGES) 설비 상태 모니터링, 진단(ECMS)·예지보전·품질 데이터 통합 도메인입니다.</p>',
        fullyQualifiedName: 'LGES',
        children: [
          {
            id: 'e7a1f2d3-c4b5-4678-9abc-def012340002',
            name: 'Equipment_Health',
            displayName: '설비 헬스',
            description: '<p>KMP·GSP·Hanwha ECMS 진단 결과, 피처 전처리 테이블 등 설비 헬스 분석 데이터</p>',
            fullyQualifiedName: 'LGES.Equipment_Health',
            children: [],
            domainType: 'Source-aligned',
            style: {},
            version: 0.1,
            updatedAt: 1769600001000,
            updatedBy: 'admin',
            parent: {
              id: 'e7a1f2d3-c4b5-4678-9abc-def012340001',
              type: 'domain',
              name: 'LGES',
              fullyQualifiedName: 'LGES',
              description:
                '<p>LG에너지솔루션(LGES) 설비 상태 모니터링, 진단(ECMS)·예지보전·품질 데이터 통합 도메인입니다.</p>',
              displayName: 'LGES',
            },
          },
        ],
        domainType: 'Consumer-aligned',
        style: {},
        version: 0.1,
        updatedAt: 1769600000000,
        updatedBy: 'admin',
      },
      {
        id: '795e251b-c697-42b9-9166-794a3a944254',
        name: 'Operations',
        displayName: '운영',
        description: '<p>설비 운영, 유지보수, 성능 모니터링 데이터를 관리하는 도메인입니다.</p>',
        fullyQualifiedName: 'Operations',
        children: [],
        domainType: 'Aggregate',
        style: {},
        version: 0.1,
        updatedAt: 1764132095920,
        updatedBy: 'admin',
      },
    ],
    paging: {
      total: 4,
    },
  };
};

/**
 * 도메인 상세 정보 목업 데이터 매핑
 */
const domainDetailMockData: Record<string, DomainItem> = {
  Manufacturing: {
    id: 'd665af17-bf56-4ef3-85d8-ea4100296c70',
    name: 'Manufacturing',
    displayName: '제조',
    description:
      '<p>제조 현장의 생산 공정 및 설비 운영 데이터를 통합 관리하는 도메인입니다. 두 제조 현장의 생산 데이터를 체계적으로 관리합니다.</p>',
    fullyQualifiedName: 'Manufacturing',
    domainType: 'Consumer-aligned',
    style: {},
    version: 0.7,
    updatedAt: 1769158862877,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/d665af17-bf56-4ef3-85d8-ea4100296c70',
    children: [
      {
        id: '13374dd4-5f8b-455b-96a0-6443dccc4a68',
        type: 'domain',
        name: 'Site_A',
        fullyQualifiedName: 'Manufacturing.Site_A',
        description: '<p>A 공장의 제조 공정 데이터</p>',
        displayName: 'A 공장',
        href: 'http://localhost:8585/api/v1/domains/13374dd4-5f8b-455b-96a0-6443dccc4a68',
      },
      {
        id: '5622f9a6-723f-43e7-a7f7-cabfb5c21995',
        type: 'domain',
        name: 'Site_B',
        fullyQualifiedName: 'Manufacturing.Site_B',
        description: '<p>B 공장의 제조 공정 데이터</p>',
        displayName: 'B 공장',
        href: 'http://localhost:8585/api/v1/domains/5622f9a6-723f-43e7-a7f7-cabfb5c21995',
      },
    ],
    owners: [
      {
        id: 'user-admin-001',
        type: 'user',
        name: 'admin',
        fullyQualifiedName: 'admin',
        displayName: '시스템 관리자',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-admin-001',
      },
    ],
    experts: [
      {
        id: 'user-expert-001',
        type: 'user',
        name: 'kim_engineer',
        fullyQualifiedName: 'kim_engineer',
        displayName: '김철수 (제조 총괄)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-expert-001',
      },
    ],
    tags: [],
    followers: [],
  },
  'Manufacturing.Site_A': {
    id: '13374dd4-5f8b-455b-96a0-6443dccc4a68',
    name: 'Site_A',
    displayName: 'A 공장',
    description:
      '<p>A 공장의 제조 공정 데이터를 관리하는 도메인입니다. CNC 가공 공정의 센서 데이터와 생산 이력을 포함합니다.</p>',
    fullyQualifiedName: 'Manufacturing.Site_A',
    domainType: 'Source-aligned',
    style: {},
    version: 0.2,
    updatedAt: 1765436112465,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/13374dd4-5f8b-455b-96a0-6443dccc4a68',
    parent: {
      id: 'd665af17-bf56-4ef3-85d8-ea4100296c70',
      type: 'domain',
      name: 'Manufacturing',
      fullyQualifiedName: 'Manufacturing',
      description:
        '<p>제조 현장의 생산 공정 및 설비 운영 데이터를 통합 관리하는 도메인입니다. 두 제조 현장의 생산 데이터를 체계적으로 관리합니다.</p>',
      displayName: '제조',
      href: 'http://localhost:8585/api/v1/domains/d665af17-bf56-4ef3-85d8-ea4100296c70',
    },
    children: [
      {
        id: '77eec04d-98eb-429c-8c40-d14278c6eec8',
        type: 'domain',
        name: 'CNC_Cell',
        fullyQualifiedName: 'Manufacturing.Site_A.CNC_Cell',
        description: '<p>A 공장의 CNC 가공 셀</p>',
        displayName: 'CNC Cell',
        href: 'http://localhost:8585/api/v1/domains/77eec04d-98eb-429c-8c40-d14278c6eec8',
      },
    ],
    owners: [
      {
        id: 'user-site-a-manager-001',
        type: 'user',
        name: 'lee_manager',
        fullyQualifiedName: 'lee_manager',
        displayName: '이영희 (A 공장 매니저)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-site-a-manager-001',
      },
    ],
    experts: [
      {
        id: 'user-site-a-expert-001',
        type: 'user',
        name: 'park_engineer',
        fullyQualifiedName: 'park_engineer',
        displayName: '박민수 (CNC 엔지니어)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-site-a-expert-001',
      },
    ],
    tags: [],
    followers: [],
  },
  'Manufacturing.Site_A.CNC_Cell': {
    id: '77eec04d-98eb-429c-8c40-d14278c6eec8',
    name: 'CNC_Cell',
    displayName: 'CNC Cell',
    description:
      '<p>A 공장의 CNC 가공 셀 데이터를 관리합니다. 다축 가공기의 절삭 공정, 공구 마모, 가공 품질 데이터를 포함합니다.</p>',
    fullyQualifiedName: 'Manufacturing.Site_A.CNC_Cell',
    domainType: 'Source-aligned',
    style: {},
    version: 0.1,
    updatedAt: 1765436215094,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/77eec04d-98eb-429c-8c40-d14278c6eec8',
    parent: {
      id: '13374dd4-5f8b-455b-96a0-6443dccc4a68',
      type: 'domain',
      name: 'Site_A',
      fullyQualifiedName: 'Manufacturing.Site_A',
      description:
        '<p>A 공장의 제조 공정 데이터를 관리하는 도메인입니다. CNC 가공 공정의 센서 데이터와 생산 이력을 포함합니다.</p>',
      displayName: 'A 공장',
      href: 'http://localhost:8585/api/v1/domains/13374dd4-5f8b-455b-96a0-6443dccc4a68',
    },
    children: [
      {
        id: 'c32d32c4-c01c-415d-8c56-547dd25f9652',
        type: 'domain',
        name: 'Turning',
        fullyQualifiedName: 'Manufacturing.Site_A.CNC_Cell.Turning',
        description: '<p>CNC Cell의 터닝 가공 공정</p>',
        displayName: '터닝 공정',
        href: 'http://localhost:8585/api/v1/domains/c32d32c4-c01c-415d-8c56-547dd25f9652',
      },
    ],
    owners: [],
    experts: [
      {
        id: 'user-cnc-expert-001',
        type: 'user',
        name: 'choi_technician',
        fullyQualifiedName: 'choi_technician',
        displayName: '최기술 (CNC 기술자)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-cnc-expert-001',
      },
    ],
    tags: [],
    followers: [],
  },
  'Manufacturing.Site_A.CNC_Cell.Turning': {
    id: 'c32d32c4-c01c-415d-8c56-547dd25f9652',
    name: 'Turning',
    displayName: '터닝 공정',
    description:
      '<p>터닝 공정의 실시간 센서 데이터 및 가공 품질 데이터를 관리합니다. 회전 속도, 이송 속도, 절삭력, 표면 조도 측정값을 포함합니다.</p>',
    fullyQualifiedName: 'Manufacturing.Site_A.CNC_Cell.Turning',
    domainType: 'Consumer-aligned',
    style: {},
    version: 0.2,
    updatedAt: 1767337947698,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/c32d32c4-c01c-415d-8c56-547dd25f9652',
    parent: {
      id: '77eec04d-98eb-429c-8c40-d14278c6eec8',
      type: 'domain',
      name: 'CNC_Cell',
      fullyQualifiedName: 'Manufacturing.Site_A.CNC_Cell',
      description:
        '<p>A 공장의 CNC 가공 셀 데이터를 관리합니다. 다축 가공기의 절삭 공정, 공구 마모, 가공 품질 데이터를 포함합니다.</p>',
      displayName: 'CNC Cell',
      href: 'http://localhost:8585/api/v1/domains/77eec04d-98eb-429c-8c40-d14278c6eec8',
    },
    children: [],
    owners: [],
    experts: [
      {
        id: 'user-turning-expert-001',
        type: 'user',
        name: 'jung_operator',
        fullyQualifiedName: 'jung_operator',
        displayName: '정현우 (터닝 오퍼레이터)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-turning-expert-001',
      },
    ],
    tags: [
      {
        tagFQN: 'ProcessData.RealTime',
        name: 'RealTime',
        displayName: '실시간 데이터',
        description: '실시간으로 수집되는 센서 데이터',
        style: {},
        source: 'Classification',
        labelType: 'Manual',
        state: 'Confirmed',
      },
    ],
    followers: [],
  },
  'Manufacturing.Site_B': {
    id: '5622f9a6-723f-43e7-a7f7-cabfb5c21995',
    name: 'Site_B',
    displayName: 'B 공장',
    description: '<p>B 공장의 제조 데이터를 관리하는 도메인입니다. MCT 셀의 고정밀 가공 데이터를 포함합니다.</p>',
    fullyQualifiedName: 'Manufacturing.Site_B',
    domainType: 'Source-aligned',
    style: {},
    version: 0.2,
    updatedAt: 1765432113789,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/5622f9a6-723f-43e7-a7f7-cabfb5c21995',
    parent: {
      id: 'd665af17-bf56-4ef3-85d8-ea4100296c70',
      type: 'domain',
      name: 'Manufacturing',
      fullyQualifiedName: 'Manufacturing',
      description:
        '<p>제조 현장의 생산 공정 및 설비 운영 데이터를 통합 관리하는 도메인입니다. 두 제조 현장의 생산 데이터를 체계적으로 관리합니다.</p>',
      displayName: '제조',
      href: 'http://localhost:8585/api/v1/domains/d665af17-bf56-4ef3-85d8-ea4100296c70',
    },
    children: [
      {
        id: 'd510bfa1-5ad5-47ac-9960-9b33e733bef5',
        type: 'domain',
        name: 'MCT_Cell',
        fullyQualifiedName: 'Manufacturing.Site_B.MCT_Cell',
        description: '<p>B 공장의 MCT 가공 셀</p>',
        displayName: 'MCT Cell',
        href: 'http://localhost:8585/api/v1/domains/d510bfa1-5ad5-47ac-9960-9b33e733bef5',
      },
    ],
    owners: [
      {
        id: 'user-site-b-manager-001',
        type: 'user',
        name: 'kang_manager',
        fullyQualifiedName: 'kang_manager',
        displayName: '강지훈 (B 공장 센터장)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-site-b-manager-001',
      },
    ],
    experts: [],
    tags: [],
    followers: [],
  },
  'Manufacturing.Site_B.MCT_Cell': {
    id: 'd510bfa1-5ad5-47ac-9960-9b33e733bef5',
    name: 'MCT_Cell',
    displayName: 'MCT Cell',
    description:
      '<p>B 공장의 머시닝 센터(MCT) 가공 셀입니다. 밀링, 드릴링 등 다양한 가공 공정의 데이터를 수집하고 관리합니다.</p>',
    fullyQualifiedName: 'Manufacturing.Site_B.MCT_Cell',
    domainType: 'Source-aligned',
    style: {},
    version: 0.1,
    updatedAt: 1765432210158,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/d510bfa1-5ad5-47ac-9960-9b33e733bef5',
    parent: {
      id: '5622f9a6-723f-43e7-a7f7-cabfb5c21995',
      type: 'domain',
      name: 'Site_B',
      fullyQualifiedName: 'Manufacturing.Site_B',
      description: '<p>B 공장의 제조 데이터를 관리하는 도메인입니다. MCT 셀의 고정밀 가공 데이터를 포함합니다.</p>',
      displayName: 'B 공장',
      href: 'http://localhost:8585/api/v1/domains/5622f9a6-723f-43e7-a7f7-cabfb5c21995',
    },
    children: [
      {
        id: '1251bff6-dfd1-4d5c-9844-691a33f15b5a',
        type: 'domain',
        name: 'Milling',
        fullyQualifiedName: 'Manufacturing.Site_B.MCT_Cell.Milling',
        description: '<p>MCT Cell의 밀링 가공 공정</p>',
        displayName: '밀링 공정',
        href: 'http://localhost:8585/api/v1/domains/1251bff6-dfd1-4d5c-9844-691a33f15b5a',
      },
    ],
    owners: [],
    experts: [
      {
        id: 'user-mct-expert-001',
        type: 'user',
        name: 'song_technician',
        fullyQualifiedName: 'song_technician',
        displayName: '송민호 (MCT 기술자)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-mct-expert-001',
      },
    ],
    tags: [],
    followers: [],
  },
  'Manufacturing.Site_B.MCT_Cell.Milling': {
    id: '1251bff6-dfd1-4d5c-9844-691a33f15b5a',
    name: 'Milling',
    displayName: '밀링 공정',
    description:
      '<p>밀링 가공 공정의 센서 데이터를 관리합니다. 주축 회전수, 절삭 속도, 이송 속도, 공구 마모량, 표면 거칠기 측정 데이터를 포함합니다.</p>',
    fullyQualifiedName: 'Manufacturing.Site_B.MCT_Cell.Milling',
    domainType: 'Source-aligned',
    style: {},
    version: 0.1,
    updatedAt: 1765432598761,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/1251bff6-dfd1-4d5c-9844-691a33f15b5a',
    parent: {
      id: 'd510bfa1-5ad5-47ac-9960-9b33e733bef5',
      type: 'domain',
      name: 'MCT_Cell',
      fullyQualifiedName: 'Manufacturing.Site_B.MCT_Cell',
      description:
        '<p>B 공장의 머시닝 센터(MCT) 가공 셀입니다. 밀링, 드릴링 등 다양한 가공 공정의 데이터를 수집하고 관리합니다.</p>',
      displayName: 'MCT Cell',
      href: 'http://localhost:8585/api/v1/domains/d510bfa1-5ad5-47ac-9960-9b33e733bef5',
    },
    children: [],
    owners: [],
    experts: [
      {
        id: 'user-milling-expert-001',
        type: 'user',
        name: 'han_operator',
        fullyQualifiedName: 'han_operator',
        displayName: '한수진 (밀링 오퍼레이터)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-milling-expert-001',
      },
    ],
    tags: [
      {
        tagFQN: 'ProcessData.RealTime',
        name: 'RealTime',
        displayName: '실시간 데이터',
        description: '실시간으로 수집되는 센서 데이터',
        style: {},
        source: 'Classification',
        labelType: 'Manual',
        state: 'Confirmed',
      },
    ],
    followers: [],
  },
  Quality: {
    id: 'ba5b2571-b2f6-48da-a22f-c0898ac0c8c1',
    name: 'Quality',
    displayName: '품질',
    description:
      '<p>제조 품질 관리 통합 도메인입니다. 검사, 시험, 불량 분석 등 품질 보증 활동의 모든 데이터를 체계적으로 관리합니다.</p>',
    fullyQualifiedName: 'Quality',
    domainType: 'Aggregate',
    style: {},
    version: 0.5,
    updatedAt: 1769597514838,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/ba5b2571-b2f6-48da-a22f-c0898ac0c8c1',
    children: [
      {
        id: '85048805-adc4-4293-9d9a-5cb1b265cf40',
        type: 'domain',
        name: 'Inspection',
        fullyQualifiedName: 'Quality.Inspection',
        description: '<p>생산 라인에서 수행되는 정규 검사 데이터를 다루는 도메인</p>',
        displayName: '검사',
        href: 'http://localhost:8585/api/v1/domains/85048805-adc4-4293-9d9a-5cb1b265cf40',
      },
      {
        id: '63b02c08-b57c-4fab-8645-591dfa03de0c',
        type: 'domain',
        name: 'Defect_Analysis',
        fullyQualifiedName: 'Quality.Defect_Analysis',
        description: '<p>검사 결과, 불량 코드, 불량률 및 원인 분석 데이터를 관리하는 도메인</p>',
        displayName: '불량 분석',
        href: 'http://localhost:8585/api/v1/domains/63b02c08-b57c-4fab-8645-591dfa03de0c',
      },
      {
        id: 'dadaca9a-5784-421a-9814-67c5ad2dd4cc',
        type: 'domain',
        name: 'Testing',
        fullyQualifiedName: 'Quality.Testing',
        description: '<p>제품 시험 및 검증 데이터를 관리하는 도메인</p>',
        displayName: '시험',
        href: 'http://localhost:8585/api/v1/domains/dadaca9a-5784-421a-9814-67c5ad2dd4cc',
      },
    ],
    owners: [
      {
        id: 'user-quality-manager-001',
        type: 'user',
        name: 'yoon_manager',
        fullyQualifiedName: 'yoon_manager',
        displayName: '윤서영 (품질 관리 부장)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-quality-manager-001',
      },
    ],
    experts: [
      {
        id: 'user-quality-expert-001',
        type: 'user',
        name: 'oh_inspector',
        fullyQualifiedName: 'oh_inspector',
        displayName: '오지혜 (품질 검사원)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-quality-expert-001',
      },
    ],
    tags: [
      {
        tagFQN: 'QualityControl.Critical',
        name: 'Critical',
        displayName: '핵심 품질 지표',
        description: '핵심 품질 관리 데이터',
        style: {},
        source: 'Classification',
        labelType: 'Manual',
        state: 'Confirmed',
      },
    ],
    followers: [],
  },
  'Quality.Inspection': {
    id: '85048805-adc4-4293-9d9a-5cb1b265cf40',
    name: 'Inspection',
    displayName: '검사',
    description:
      '<p>생산 라인에서 수행되는 정규 검사 데이터를 관리합니다. 치수 검사, 외관 검사 등 제품 품질을 보증하기 위한 모든 검사 활동의 데이터를 포함합니다.</p>',
    fullyQualifiedName: 'Quality.Inspection',
    domainType: 'Source-aligned',
    style: {},
    version: 0.2,
    updatedAt: 1764208471116,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/85048805-adc4-4293-9d9a-5cb1b265cf40',
    parent: {
      id: 'ba5b2571-b2f6-48da-a22f-c0898ac0c8c1',
      type: 'domain',
      name: 'Quality',
      fullyQualifiedName: 'Quality',
      description:
        '<p>제조 품질 관리 통합 도메인입니다. 검사, 시험, 불량 분석 등 품질 보증 활동의 모든 데이터를 체계적으로 관리합니다.</p>',
      displayName: '품질',
      href: 'http://localhost:8585/api/v1/domains/ba5b2571-b2f6-48da-a22f-c0898ac0c8c1',
    },
    children: [
      {
        id: '743ccea1-10e4-44a2-b9ba-5deda23f4108',
        type: 'domain',
        name: 'Dimensional',
        fullyQualifiedName: 'Quality.Inspection.Dimensional',
        description: '<p>3차원 측정기 등에서 수집된 치수 검사 데이터를 관리하는 도메인</p>',
        displayName: '치수 검사',
        href: 'http://localhost:8585/api/v1/domains/743ccea1-10e4-44a2-b9ba-5deda23f4108',
      },
      {
        id: 'd6c0419f-fc91-4956-a1b8-68e6f210115a',
        type: 'domain',
        name: 'Visual',
        fullyQualifiedName: 'Quality.Inspection.Visual',
        description: '<p>스크래치, 찍힘 등 외관 불량 검사 데이터를 다루는 도메인</p>',
        displayName: '외관 검사',
        href: 'http://localhost:8585/api/v1/domains/d6c0419f-fc91-4956-a1b8-68e6f210115a',
      },
    ],
    owners: [
      {
        id: 'user-inspection-lead-001',
        type: 'user',
        name: 'lim_inspector',
        fullyQualifiedName: 'lim_inspector',
        displayName: '임준호 (검사 팀장)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-inspection-lead-001',
      },
    ],
    experts: [],
    tags: [],
    followers: [],
  },
  'Quality.Inspection.Dimensional': {
    id: '743ccea1-10e4-44a2-b9ba-5deda23f4108',
    name: 'Dimensional',
    displayName: '치수 검사',
    description:
      '<p>3차원 측정기(CMM), 캘리퍼스 등으로 측정한 치수 검사 데이터를 관리합니다. 규격값, 실측값, 공차 범위, 합격/불합격 판정 결과를 포함합니다.</p>',
    fullyQualifiedName: 'Quality.Inspection.Dimensional',
    domainType: 'Source-aligned',
    style: {},
    version: 0.1,
    updatedAt: 1764208587966,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/743ccea1-10e4-44a2-b9ba-5deda23f4108',
    parent: {
      id: '85048805-adc4-4293-9d9a-5cb1b265cf40',
      type: 'domain',
      name: 'Inspection',
      fullyQualifiedName: 'Quality.Inspection',
      description:
        '<p>생산 라인에서 수행되는 정규 검사 데이터를 관리합니다. 치수 검사, 외관 검사 등 제품 품질을 보증하기 위한 모든 검사 활동의 데이터를 포함합니다.</p>',
      displayName: '검사',
      href: 'http://localhost:8585/api/v1/domains/85048805-adc4-4293-9d9a-5cb1b265cf40',
    },
    children: [],
    owners: [],
    experts: [
      {
        id: 'user-dimension-expert-001',
        type: 'user',
        name: 'bae_inspector',
        fullyQualifiedName: 'bae_inspector',
        displayName: '배성민 (치수 검사원)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-dimension-expert-001',
      },
    ],
    tags: [
      {
        tagFQN: 'QualityControl.Measurement',
        name: 'Measurement',
        displayName: '측정 데이터',
        description: '정밀 측정 장비로 수집된 데이터',
        style: {},
        source: 'Classification',
        labelType: 'Manual',
        state: 'Confirmed',
      },
    ],
    followers: [],
  },
  'Quality.Inspection.Visual': {
    id: 'd6c0419f-fc91-4956-a1b8-68e6f210115a',
    name: 'Visual',
    displayName: '외관 검사',
    description:
      '<p>제품 외관의 결함을 검사한 데이터를 관리합니다. 스크래치, 찍힘, 도장 불량, 변색 등 육안 및 이미지 검사 결과를 포함합니다.</p>',
    fullyQualifiedName: 'Quality.Inspection.Visual',
    domainType: 'Source-aligned',
    style: {},
    version: 0.1,
    updatedAt: 1764208620802,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/d6c0419f-fc91-4956-a1b8-68e6f210115a',
    parent: {
      id: '85048805-adc4-4293-9d9a-5cb1b265cf40',
      type: 'domain',
      name: 'Inspection',
      fullyQualifiedName: 'Quality.Inspection',
      description:
        '<p>생산 라인에서 수행되는 정규 검사 데이터를 관리합니다. 치수 검사, 외관 검사 등 제품 품질을 보증하기 위한 모든 검사 활동의 데이터를 포함합니다.</p>',
      displayName: '검사',
      href: 'http://localhost:8585/api/v1/domains/85048805-adc4-4293-9d9a-5cb1b265cf40',
    },
    children: [],
    owners: [],
    experts: [
      {
        id: 'user-visual-expert-001',
        type: 'user',
        name: 'noh_inspector',
        fullyQualifiedName: 'noh_inspector',
        displayName: '노지원 (외관 검사원)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-visual-expert-001',
      },
    ],
    tags: [],
    followers: [],
  },
  'Quality.Defect_Analysis': {
    id: '63b02c08-b57c-4fab-8645-591dfa03de0c',
    name: 'Defect_Analysis',
    displayName: '불량 분석',
    description:
      '<p>검사 결과 발견된 불량 데이터와 분석 리포트를 관리합니다. 불량 코드, 불량률 추이, 파레토 분석, 근본 원인 분석(RCA) 데이터를 포함합니다.</p>',
    fullyQualifiedName: 'Quality.Defect_Analysis',
    domainType: 'Source-aligned',
    style: {},
    version: 0.2,
    updatedAt: 1763086102763,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/63b02c08-b57c-4fab-8645-591dfa03de0c',
    parent: {
      id: 'ba5b2571-b2f6-48da-a22f-c0898ac0c8c1',
      type: 'domain',
      name: 'Quality',
      fullyQualifiedName: 'Quality',
      description:
        '<p>제조 품질 관리 통합 도메인입니다. 검사, 시험, 불량 분석 등 품질 보증 활동의 모든 데이터를 체계적으로 관리합니다.</p>',
      displayName: '품질',
      href: 'http://localhost:8585/api/v1/domains/ba5b2571-b2f6-48da-a22f-c0898ac0c8c1',
    },
    children: [],
    owners: [],
    experts: [
      {
        id: 'user-defects-analyst-001',
        type: 'user',
        name: 'seo_analyst',
        fullyQualifiedName: 'seo_analyst',
        displayName: '서준영 (불량 분석가)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-defects-analyst-001',
      },
    ],
    tags: [
      {
        tagFQN: 'Analytics.Statistical',
        name: 'Statistical',
        displayName: '통계 분석',
        description: '통계적 분석이 필요한 데이터',
        style: {},
        source: 'Classification',
        labelType: 'Manual',
        state: 'Confirmed',
      },
    ],
    followers: [],
  },
  'Quality.Testing': {
    id: 'dadaca9a-5784-421a-9814-67c5ad2dd4cc',
    name: 'Testing',
    displayName: '시험',
    description:
      '<p>제품의 기능, 내구성, 환경 적응성을 검증하는 시험 데이터를 관리합니다. 다양한 시험 벤치와 챔버에서 수집된 시험 결과를 포함합니다.</p>',
    fullyQualifiedName: 'Quality.Testing',
    domainType: 'Consumer-aligned',
    style: {},
    version: 0.2,
    updatedAt: 1769589086211,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/dadaca9a-5784-421a-9814-67c5ad2dd4cc',
    parent: {
      id: 'ba5b2571-b2f6-48da-a22f-c0898ac0c8c1',
      type: 'domain',
      name: 'Quality',
      fullyQualifiedName: 'Quality',
      description:
        '<p>제조 품질 관리 통합 도메인입니다. 검사, 시험, 불량 분석 등 품질 보증 활동의 모든 데이터를 체계적으로 관리합니다.</p>',
      displayName: '품질',
      href: 'http://localhost:8585/api/v1/domains/ba5b2571-b2f6-48da-a22f-c0898ac0c8c1',
    },
    children: [
      {
        id: '59d47ee9-1c87-4f68-a31c-b18c99850e93',
        type: 'domain',
        name: 'Durability',
        fullyQualifiedName: 'Quality.Testing.Durability',
        description: '<p>반복 하중, 장시간 운전 등 내구 시험 데이터를 다루는 도메인</p>',
        displayName: '내구 시험',
        href: 'http://localhost:8585/api/v1/domains/59d47ee9-1c87-4f68-a31c-b18c99850e93',
      },
      {
        id: 'a20e23d2-924f-4d9c-84dc-1045a603b2bf',
        type: 'domain',
        name: 'Environmental',
        fullyQualifiedName: 'Quality.Testing.Environmental',
        description: '<p>고온·저온·습도 등 환경 시험 데이터를 관리하는 도메인</p>',
        displayName: '환경 시험',
        href: 'http://localhost:8585/api/v1/domains/a20e23d2-924f-4d9c-84dc-1045a603b2bf',
      },
      {
        id: '3e93335b-3b04-4238-a24d-ffece1cec098',
        type: 'domain',
        name: 'Functional',
        fullyQualifiedName: 'Quality.Testing.Functional',
        description: '<p>브레이크, 조향 등 기능 시험 벤치 데이터를 관리하는 도메인</p>',
        displayName: '기능 시험',
        href: 'http://localhost:8585/api/v1/domains/3e93335b-3b04-4238-a24d-ffece1cec098',
      },
    ],
    owners: [
      {
        id: 'user-test-manager-001',
        type: 'user',
        name: 'jang_manager',
        fullyQualifiedName: 'jang_manager',
        displayName: '장민석 (시험 팀장)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-test-manager-001',
      },
    ],
    experts: [],
    tags: [],
    followers: [],
  },
  'Quality.Testing.Durability': {
    id: '59d47ee9-1c87-4f68-a31c-b18c99850e93',
    name: 'Durability',
    displayName: '내구 시험',
    description:
      '<p>부품 및 제품의 내구성을 검증하는 시험 데이터를 관리합니다. 반복 하중 시험, 피로 시험, 장시간 운전 시험 결과 및 예상 수명 평가 데이터를 포함합니다.</p>',
    fullyQualifiedName: 'Quality.Testing.Durability',
    domainType: 'Source-aligned',
    style: {},
    version: 0.2,
    updatedAt: 1772526995115,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/59d47ee9-1c87-4f68-a31c-b18c99850e93',
    parent: {
      id: 'dadaca9a-5784-421a-9814-67c5ad2dd4cc',
      type: 'domain',
      name: 'Testing',
      fullyQualifiedName: 'Quality.Testing',
      description:
        '<p>제품의 기능, 내구성, 환경 적응성을 검증하는 시험 데이터를 관리합니다. 다양한 시험 벤치와 챔버에서 수집된 시험 결과를 포함합니다.</p>',
      displayName: '시험',
      href: 'http://localhost:8585/api/v1/domains/dadaca9a-5784-421a-9814-67c5ad2dd4cc',
    },
    children: [],
    owners: [],
    experts: [
      {
        id: 'user-durability-expert-001',
        type: 'user',
        name: 'kwon_engineer',
        fullyQualifiedName: 'kwon_engineer',
        displayName: '권태영 (내구 시험 엔지니어)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-durability-expert-001',
      },
    ],
    tags: [],
    followers: [],
  },
  'Quality.Testing.Environmental': {
    id: 'a20e23d2-924f-4d9c-84dc-1045a603b2bf',
    name: 'Environmental',
    displayName: '환경 시험',
    description:
      '<p>다양한 환경 조건에서의 제품 성능을 검증하는 시험 데이터를 관리합니다. 고온·저온·습도·염수 분무·진동·충격 등 환경 챔버 시험 결과를 포함합니다.</p>',
    fullyQualifiedName: 'Quality.Testing.Environmental',
    domainType: 'Source-aligned',
    style: {},
    version: 0.1,
    updatedAt: 1764208761318,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/a20e23d2-924f-4d9c-84dc-1045a603b2bf',
    parent: {
      id: 'dadaca9a-5784-421a-9814-67c5ad2dd4cc',
      type: 'domain',
      name: 'Testing',
      fullyQualifiedName: 'Quality.Testing',
      description:
        '<p>제품의 기능, 내구성, 환경 적응성을 검증하는 시험 데이터를 관리합니다. 다양한 시험 벤치와 챔버에서 수집된 시험 결과를 포함합니다.</p>',
      displayName: '시험',
      href: 'http://localhost:8585/api/v1/domains/dadaca9a-5784-421a-9814-67c5ad2dd4cc',
    },
    children: [],
    owners: [],
    experts: [
      {
        id: 'user-environmental-expert-001',
        type: 'user',
        name: 'moon_technician',
        fullyQualifiedName: 'moon_technician',
        displayName: '문지훈 (환경 시험 기술자)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-environmental-expert-001',
      },
    ],
    tags: [],
    followers: [],
  },
  'Quality.Testing.Functional': {
    id: '3e93335b-3b04-4238-a24d-ffece1cec098',
    name: 'Functional',
    displayName: '기능 시험',
    description:
      '<p>부품 및 시스템의 기능 성능을 검증하는 시험 데이터를 관리합니다. 브레이크, 조향, 구동 시스템 등의 기능 시험 벤치 데이터, 시험 조건, 측정값, 합격/불합격 판정을 포함합니다.</p>',
    fullyQualifiedName: 'Quality.Testing.Functional',
    domainType: 'Source-aligned',
    style: {},
    version: 0.1,
    updatedAt: 1764208679118,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/3e93335b-3b04-4238-a24d-ffece1cec098',
    parent: {
      id: 'dadaca9a-5784-421a-9814-67c5ad2dd4cc',
      type: 'domain',
      name: 'Testing',
      fullyQualifiedName: 'Quality.Testing',
      description:
        '<p>제품의 기능, 내구성, 환경 적응성을 검증하는 시험 데이터를 관리합니다. 다양한 시험 벤치와 챔버에서 수집된 시험 결과를 포함합니다.</p>',
      displayName: '시험',
      href: 'http://localhost:8585/api/v1/domains/dadaca9a-5784-421a-9814-67c5ad2dd4cc',
    },
    children: [],
    owners: [],
    experts: [
      {
        id: 'user-functional-expert-001',
        type: 'user',
        name: 'shin_engineer',
        fullyQualifiedName: 'shin_engineer',
        displayName: '신동욱 (기능 시험 엔지니어)',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-functional-expert-001',
      },
    ],
    tags: [],
    followers: [],
  },
  LGES: {
    id: 'e7a1f2d3-c4b5-4678-9abc-def012340001',
    name: 'LGES',
    displayName: 'LGES',
    description:
      '<p>LG에너지솔루션 설비 상태, ECMS 진단, 예지보전 및 관련 분석 테이블을 통합 관리하는 루트 도메인입니다.</p>',
    fullyQualifiedName: 'LGES',
    domainType: 'Consumer-aligned',
    style: {},
    version: 0.1,
    updatedAt: 1769600000000,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/e7a1f2d3-c4b5-4678-9abc-def012340001',
    children: [
      {
        id: 'e7a1f2d3-c4b5-4678-9abc-def012340002',
        type: 'domain',
        name: 'Equipment_Health',
        fullyQualifiedName: 'LGES.Equipment_Health',
        description: '<p>KMP·GSP·Hanwha ECMS 진단·피처 데이터</p>',
        displayName: '설비 헬스',
        href: 'http://localhost:8585/api/v1/domains/e7a1f2d3-c4b5-4678-9abc-def012340002',
      },
    ],
    owners: [
      {
        id: 'user-lges-owner-001',
        type: 'user',
        name: 'lges_data_owner',
        fullyQualifiedName: 'lges_data_owner',
        displayName: 'LGES 데이터 도메인 오너',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-lges-owner-001',
      },
    ],
    experts: [],
    tags: [],
    followers: [],
  },
  'LGES.Equipment_Health': {
    id: 'e7a1f2d3-c4b5-4678-9abc-def012340002',
    name: 'Equipment_Health',
    displayName: '설비 헬스',
    description:
      '<p>ECMS 기반 진단 결과, 피처 전처리 테이블, 설비 이상 신호 분석 산출물을 포함하는 LGES 설비 헬스 하위 도메인입니다.</p>',
    fullyQualifiedName: 'LGES.Equipment_Health',
    domainType: 'Source-aligned',
    style: {},
    version: 0.1,
    updatedAt: 1769600001000,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/e7a1f2d3-c4b5-4678-9abc-def012340002',
    parent: {
      id: 'e7a1f2d3-c4b5-4678-9abc-def012340001',
      type: 'domain',
      name: 'LGES',
      fullyQualifiedName: 'LGES',
      description:
        '<p>LG에너지솔루션 설비 상태, ECMS 진단, 예지보전 및 관련 분석 테이블을 통합 관리하는 루트 도메인입니다.</p>',
      displayName: 'LGES',
      href: 'http://localhost:8585/api/v1/domains/e7a1f2d3-c4b5-4678-9abc-def012340001',
    },
    children: [],
    owners: [],
    experts: [
      {
        id: 'user-lges-expert-001',
        type: 'user',
        name: 'lges_health_analyst',
        fullyQualifiedName: 'lges_health_analyst',
        displayName: 'LGES 헬스 분석가',
        deleted: false,
        href: 'http://localhost:8585/api/v1/users/user-lges-expert-001',
      },
    ],
    tags: [],
    followers: [],
  },
  Operations: {
    id: '795e251b-c697-42b9-9166-794a3a944254',
    name: 'Operations',
    displayName: '운영',
    description:
      '<p>설비 운영, 유지보수, 성능 모니터링 데이터를 관리하는 도메인입니다. 설비 가동률, 고장 이력, 예방 정비 데이터를 포함합니다.</p>',
    fullyQualifiedName: 'Operations',
    domainType: 'Aggregate',
    style: {},
    version: 0.1,
    updatedAt: 1764132095920,
    updatedBy: 'admin',
    href: 'http://localhost:8585/api/v1/domains/795e251b-c697-42b9-9166-794a3a944254',
    children: [],
    owners: [],
    experts: [],
    tags: [],
    followers: [],
  },
};

/**
 * FQN으로 도메인 상세 정보를 조회합니다.
 */
export const getDomainDetailByFqn = (fqn: string): DomainItem | null => {
  return domainDetailMockData[fqn] || null;
};

/**
 * 특정 부모 도메인의 하위 도메인 목록을 검색 형식으로 반환합니다.
 */
export const getSubDomainsByParentFqn = (parentFqn: string): SubDomainSearchResponse => {
  const allDomains = Object.values(domainDetailMockData);
  const subDomains = allDomains.filter((domain) => domain.parent?.fullyQualifiedName === parentFqn);

  return {
    took: 5,
    timed_out: false,
    _shards: {
      total: 1,
      successful: 1,
      skipped: 0,
      failed: 0,
    },
    hits: {
      total: {
        value: subDomains.length,
        relation: 'eq',
      },
      max_score: 1.0,
      hits: subDomains.map((domain) => ({
        _index: 'domain_search_index',
        _id: domain.id,
        _score: 1.0,
        _source: domain,
      })),
    },
  };
};

/**
 * 팀 소유자 목업 데이터
 */
const teamOwnersMockData: TeamOwner[] = [
  {
    id: 'team-quality-001',
    teamType: 'Group',
    name: 'quality_team',
    fullyQualifiedName: 'quality_team',
    displayName: '품질 관리 팀',
    description: '품질 관리 및 검사를 담당하는 팀',
    deleted: false,
  },
  {
    id: 'team-manufacturing-001',
    teamType: 'Group',
    name: 'manufacturing_team',
    fullyQualifiedName: 'manufacturing_team',
    displayName: '제조 팀',
    description: '제조 공정을 담당하는 팀',
    deleted: false,
  },
  {
    id: 'team-engineering-001',
    teamType: 'Group',
    name: 'engineering_team',
    fullyQualifiedName: 'engineering_team',
    displayName: '엔지니어링 팀',
    description: '설계 및 엔지니어링 팀',
    deleted: false,
  },
];

/**
 * 사용자 소유자 목업 데이터
 */
const userOwnersMockData: UserOwner[] = [
  {
    id: 'user-admin-001',
    name: 'admin',
    fullyQualifiedName: 'admin',
    displayName: '시스템 관리자',
    email: 'admin@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-expert-001',
    name: 'kim_engineer',
    fullyQualifiedName: 'kim_engineer',
    displayName: '김철수 (제조 총괄)',
    email: 'kim.cs@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-site-a-manager-001',
    name: 'lee_manager',
    fullyQualifiedName: 'lee_manager',
    displayName: '이영희 (A 공장 매니저)',
    email: 'lee.yh@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-site-a-expert-001',
    name: 'park_engineer',
    fullyQualifiedName: 'park_engineer',
    displayName: '박민수 (CNC 엔지니어)',
    email: 'park.ms@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-cnc-expert-001',
    name: 'choi_technician',
    fullyQualifiedName: 'choi_technician',
    displayName: '최기술 (CNC 기술자)',
    email: 'choi.gs@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-turning-expert-001',
    name: 'jung_operator',
    fullyQualifiedName: 'jung_operator',
    displayName: '정현우 (터닝 오퍼레이터)',
    email: 'jung.hw@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-site-b-manager-001',
    name: 'kang_manager',
    fullyQualifiedName: 'kang_manager',
    displayName: '강지훈 (B 공장 센터장)',
    email: 'kang.jh@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-mct-expert-001',
    name: 'song_technician',
    fullyQualifiedName: 'song_technician',
    displayName: '송민호 (MCT 기술자)',
    email: 'song.mh@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-milling-expert-001',
    name: 'han_operator',
    fullyQualifiedName: 'han_operator',
    displayName: '한수진 (밀링 오퍼레이터)',
    email: 'han.sj@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-quality-manager-001',
    name: 'yoon_manager',
    fullyQualifiedName: 'yoon_manager',
    displayName: '윤서영 (품질 관리 부장)',
    email: 'yoon.sy@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-quality-expert-001',
    name: 'oh_inspector',
    fullyQualifiedName: 'oh_inspector',
    displayName: '오지혜 (품질 검사원)',
    email: 'oh.jh@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-inspection-lead-001',
    name: 'lim_inspector',
    fullyQualifiedName: 'lim_inspector',
    displayName: '임준호 (검사 팀장)',
    email: 'lim.jh@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-dimension-expert-001',
    name: 'bae_inspector',
    fullyQualifiedName: 'bae_inspector',
    displayName: '배성민 (치수 검사원)',
    email: 'bae.sm@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-visual-expert-001',
    name: 'noh_inspector',
    fullyQualifiedName: 'noh_inspector',
    displayName: '노지원 (외관 검사원)',
    email: 'noh.jw@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-defects-analyst-001',
    name: 'seo_analyst',
    fullyQualifiedName: 'seo_analyst',
    displayName: '서준영 (불량 분석가)',
    email: 'seo.jy@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-test-manager-001',
    name: 'jang_manager',
    fullyQualifiedName: 'jang_manager',
    displayName: '장민석 (시험 팀장)',
    email: 'jang.ms@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-durability-expert-001',
    name: 'kwon_engineer',
    fullyQualifiedName: 'kwon_engineer',
    displayName: '권태영 (내구 시험 엔지니어)',
    email: 'kwon.ty@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-environmental-expert-001',
    name: 'moon_technician',
    fullyQualifiedName: 'moon_technician',
    displayName: '문지훈 (환경 시험 기술자)',
    email: 'moon.jh@company.com',
    isBot: false,
    deleted: false,
  },
  {
    id: 'user-functional-expert-001',
    name: 'shin_engineer',
    fullyQualifiedName: 'shin_engineer',
    displayName: '신동욱 (기능 시험 엔지니어)',
    email: 'shin.dw@company.com',
    isBot: false,
    deleted: false,
  },
];

/**
 * 도메인 사용자 목업 데이터 (experts용)
 */
const domainUsersMockData: DomainUser[] = userOwnersMockData.map((user) => ({
  id: user.id,
  name: user.name,
  fullyQualifiedName: user.fullyQualifiedName,
  displayName: user.displayName,
  email: user.email,
  isBot: user.isBot,
}));

/**
 * 팀 소유자 목업 데이터를 반환합니다.
 */
export const getTeamOwnersMockData = () => {
  return {
    took: 5,
    timed_out: false,
    _shards: {
      total: 1,
      successful: 1,
      skipped: 0,
      failed: 0,
    },
    hits: {
      total: {
        value: teamOwnersMockData.length,
        relation: 'eq',
      },
      max_score: 1.0,
      hits: teamOwnersMockData.map((team) => ({
        _index: 'team_search_index',
        _id: team.id,
        _score: 1.0,
        _source: team,
      })),
    },
  };
};

/**
 * 사용자 소유자 목업 데이터를 반환합니다.
 */
export const getUserOwnersMockData = () => {
  return {
    took: 5,
    timed_out: false,
    _shards: {
      total: 1,
      successful: 1,
      skipped: 0,
      failed: 0,
    },
    hits: {
      total: {
        value: userOwnersMockData.length,
        relation: 'eq',
      },
      max_score: 1.0,
      hits: userOwnersMockData.map((user) => ({
        _index: 'user_search_index',
        _id: user.id,
        _score: 1.0,
        _source: user,
      })),
    },
  };
};

/**
 * 도메인 사용자 목업 데이터를 반환합니다.
 */
export const getDomainUsersMockData = (limit: number = 25) => {
  return {
    data: domainUsersMockData.slice(0, limit),
    paging: {
      total: domainUsersMockData.length,
    },
  };
};
